<template>
    <h3
        class="text-sm font-medium"
        data-spec-class="card-title"
    >
        <slot />
    </h3>
</template>
